<template>
    <SuccessScreen
        titleKey="edit-profile.success.title"
        messageKey="edit-profile.success.message"
        buttonTextKey="edit-profile.success.button-text"
        @accept="redirectToHome"
    />
</template>

<script>
import SuccessScreen from '@/components/SuccessScreen.vue';
import router from '@/router';

export default {
    name: 'ProfileUpdateSuccess',
    components: {
        SuccessScreen
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        redirectToHome() {
            router.push({ name: 'home' });
        }
    }
};
</script>